"use client";
import ColorIcon from "./ColorIcon";
import { deepCopy } from "@/functions/fns";
import DropDown from "./DropDown";
import PercentInput from "./PercentInput";
import { useState } from "react";
import SpreadRange from "./SpreadRange";
import { blendModes } from "./defaults";

export default function EditorLeafDetail({
  data,
  type,
  idx,
  config,
  setConfig,
}) {
  const [open, setOpen] = useState(false);
  const printSpreads = (c, k) => {
    const { start, end } = c;
    const id = `spreader-${idx}-${k}`;
    const cur = `${idx}-${k}`;
    const toggleOpen = () => {
      setOpen(open === cur ? false : cur);
    };
    return (
      <>
        {open === cur && (
          <SpreadRange toggleOpen={toggleOpen} arrayIdx={idx} idx={k} id={id} />
        )}
        <div id={id} className="flex flex-col" onClick={toggleOpen}>
          <PercentInput
            className="rounded-t"
            value={start}
            onChange={(e) => {
              const newConfig = deepCopy(config);
              newConfig[idx][type][k].start = e;
              setConfig(newConfig);
            }}
          />
          <PercentInput
            className="mt-px rounded-b"
            value={end}
            onChange={(e) => {
              const newConfig = deepCopy(config);
              newConfig[idx][type][k].end = e;
              setConfig(newConfig);
            }}
          />
        </div>
      </>
    );
  };
  const printInput = (c, k) => {
    return (
      <PercentInput
        value={c}
        onChange={(e) => {
          const newConfig = deepCopy(config);
          newConfig[idx][type][k] = e;
          setConfig(newConfig);
        }}
      />
    );
  };

  const printBlend = (c, k) => {
    const opts = blendModes;
    return (
      <div className="min-w-[140px]">
        <DropDown
          value={c}
          values={opts}
          onChange={(e) => {
            const newConfig = deepCopy(config);
            newConfig[idx].blend[k] = e;
            setConfig(newConfig);
          }}
        />
      </div>
    );
  };

  const print =
    type === "colors"
      ? data.map((d, k) => (
          <div className="cell" key={k}>
            <ColorIcon
              config={config}
              setConfig={setConfig}
              arrayIdx={idx}
              idx={k}
              value={d}
            />{" "}
          </div>
        ))
      : data.map((d, k) => (
          <div className={type === "blend" ? "p-2" : "cell"} key={k}>
            <div className="flexer">
              {type === "spread"
                ? printSpreads(d, k)
                : type === "blend"
                ? printBlend(d, k)
                : printInput(d, k)}
            </div>
          </div>
        ));

  return <div className="flex items-center">{print}</div>;
}
